export const MODELS_GENERIC_MODAL = {
  programming: 'programming_languages',
  DB: 'databases',
  frameworks: 'technologies_and_frameworks',
  methodologies: 'methodologies',
  softSkills: 'soft_skills',
  technicalSkills: 'technical_skills',
  hobbies: 'hobbies',
  domains: 'domains'
}

export const EXPERIENCE_MODAL_SIZES = {
  maxLengthJobTitle: 50,
  maxLengthProjectName: 50,
  maxLengthIndustrySector: 50,
  maxLengthProjectDescription: 1200,
  maxLengthAdditionalInfoTitle: 25,
  maxLengthAdditionalInfoDesc: 70,
  maxLengthAchievements: 2000,
  maxLengthJobResponsibilities: 2000
}

export const SUMMARY_MODAL_SIZES = {
  maxLengthSummary: 900,
  maxLengthRole: 200,
  maxLengthGrade: 200,
  maxLengthCoreSkill: 200
}
